import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


 
import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { ModalAgregarFactu } from './modalAgregarFactura';
import moment from 'moment';

function TablaOrdenesPorCargar(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' ', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Cod. Orden', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Cod. Compromisos', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Proveedor', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },

    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacionFactu, setOperacionFactu] = useState(0);
    const [records, setRecords] = useState([]);
    const [facturaSel, setFacturaSel] = useState();
    const [habiBot, setHabiBot] = useState(false);
    const [itemSelect, setItemSelect] = useState(-1);
    const [totalFactu, setTotalFactu] = useState(0.00);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const txtMonto = useRef([]);
    const txtTotalFacturas = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        //blanquearCampos();
        setOperacionFactu(ope);
        if (ope === 1) {
            if (props.nombreprov.trim() !== '') {
                if (props.dataIsrl.length > 0) {
                    setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Ya existe la retención I.S.L.R. en base a estas Facturas\nSi agrega una Factura se eliminara esa retención.', icono: 'confirmacion' });
                } else {
                    setMostrar5(true);
                    blanquearCampos()
                }

            }


        } else if (ope === 2 && itemSelect >= 0) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Se eliminaran todas las retenciones de esta factura\nEsta seguro de Editar el registro?', icono: 'confirmacion' });
            //setMostrar5(true);
        } else if (ope === 3) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Está seguro de eliminar el registro?', icono: 'confirmacion' });
            //setMostrar5(true);
            //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        let data = [...records];
        let index = -1;
        if (operacionFactu === 1) {
            //for (let i = 0; i < datos.length; i++) {

            data.push({
                numoperacion: datos[0].numoperacion,
                numfactura: datos[0].numfactura,
                numcontrol: datos[0].numcontrol,
                fecfactura: datos[0].fecfactura,
                subtotal: datos[0].subtotal,
                otros: datos[0].otros,
                ajuste: datos[0].ajuste,
                exento: datos[0].exento,
                baseimponible: datos[0].baseimponible,
                porceiva: datos[0].porceiva,
                total: datos[0].total,
            });

            //}
            index = data.length - 1;
            setItemSelect(data.length - 1);
        } else if (operacionFactu === 2) {
            data[itemSelect].numoperacion = datos[0].numoperacion;
            data[itemSelect].numfactura = datos[0].numfactura;
            data[itemSelect].numcontrol = datos[0].numcontrol;
            data[itemSelect].fecfactura = datos[0].fecfactura;
            data[itemSelect].subtotal = datos[0].subtotal;
            data[itemSelect].otros = datos[0].otros;
            data[itemSelect].ajuste = datos[0].ajuste;
            data[itemSelect].exento = datos[0].exento;
            data[itemSelect].baseimponible = datos[0].baseimponible;
            data[itemSelect].porceiva = datos[0].porceiva;
            data[itemSelect].total = datos[0].total;
            index = itemSelect;
        }
        var totFact = 0.00;
        for (let i = 0; i < data.length; i++) {
            totFact = totFact + data[i].total;
        }
        totFact = Math.round(parseFloat(totFact) * Math.pow(10, 4)) / Math.pow(10, 4);
        setTotalFactu(totFact);
        txtTotalFacturas.current.value = formatMoneda(totFact.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setRecords(data);
        props.data(data, index, operacionFactu, datos[0].numfactura);
    }

    useEffect(() => {
        /* setHabiBot(false);
        blanquearCampos();
        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];
            var totFact = 0.00;
            for (let i = 0; i < data.length; i++) {

                datos.push({
                    numoperacion: data[i].numoperacion,
                    numfactura: data[i].numfactura,
                    numcontrol: data[i].numcontrol,
                    fecfactura: data[i].fecfactura,
                    subtotal: data[i].subtotal,
                    otros: data[i].otros,
                    ajuste: data[i].ajuste,
                    exento: data[i].exento,
                    baseimponible: data[i].baseimponible,
                    porceiva: data[i].porceiva,
                    total: data[i].total,

                });
                totFact = totFact + data[i].total;
            }
            if (props.tipocomp === 13) {
                setHabiBot(true);
            }
            totFact = Math.round(parseFloat(totFact) * Math.pow(10, 4)) / Math.pow(10, 4);
            setTotalFactu(totFact);
            txtTotalFacturas.current.value = formatMoneda(totFact.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            console.log(datos);
            setRecords(datos);
            props.data(datos, itemSelect, 0, data[itemSelect < 0 ? 0 : itemSelect].numfactura);
        } else {
            setRecords([]);
        } */


    }, [/* props.datarecords */]);

    const eliminarFactura = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idcompromiso !== datos[i].idcompromiso) {
                elementos.push(datos[i]);
            }

        }

        setRecords(elementos);
        props.data(elementos);
    }

    const seleccionarFila = (index) => (e) => {
        //if (props.operacion === 1){
        e.preventDefault();
        setItemSelect(index);
        setFacturaSel(records[index]);
        props.data(records, index, 0);
        //}

    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (operacionFactu === 3) {
            let numfact = records[itemSelect].numfactura;
            let data = [...records.filter((it) => it.numfactura !== numfact)];
            var totFact = 0.00;
            for (let i = 0; i < data.length; i++) {
                totFact = totFact + data[i].total;
            }
            totFact = Math.round(parseFloat(totFact) * Math.pow(10, 4)) / Math.pow(10, 4);
            setTotalFactu(totFact);
            txtTotalFacturas.current.value = formatMoneda(totFact.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords(data);
            setItemSelect(0);
            setFacturaSel(data[0]);
            props.data(data, 0, operacionFactu, numfact);
        } else {
            props.onHideEliminarRetIsrl();
            setMostrar5(true);
            //setOperacion(1);
            blanquearCampos()
        }
    };

    return (
        <div className='col-md-12 mx-auto px-0'>

            <ModalAgregarFactu
                show={mostrar5}
                operacion={operacionFactu}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                facturas={records}
                facturasel={facturaSel}
                totalfactu={totalFactu}
                montoorden={props.montocompro}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>



            <div className="row col-md-12 mx-auto px-0">


                <TblContainer container={{ height: 150, width: '100%', overflow: 'auto', padding: '2px' }}>
                    <TblHead />

                    <tbody>
                        {

                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={item + item.numfactura} className="table-bordered" style={{ padding: "0", height: '40px', cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                    <td style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>{item.numfactura}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center", width: '60px' }}>{item.numcontrol}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>{moment.utc(item.fecfactura).format('DD/MM/YYYY')}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right", width: "100px" }}>{formatMoneda(item.subtotal.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right", width: "100px" }}>{formatMoneda(item.otros.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right", width: "100px" }}>{formatMoneda(item.ajuste.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                </tr>

                            ))
                        }
                    </tbody>

                </TblContainer>



            </div>


        </div>

    );

}

export default TablaOrdenesPorCargar;
